export default __webpack_public_path__ + "static/media/tournaments.3a96bc17.svg";